module.exports = __webpack_public_path__ + "img/BLITZ POSITANO-398-retro-min.55fc51ce.jpg";